import { useCurrentEditor, useEditorState } from "@tiptap/react";
import type { FC } from "react";

import { EditorButton, type EditorButtonProps } from "./editor-button";

export const EditorButtonUnderline: FC<EditorButtonProps> = (props) => {
  const { editor } = useCurrentEditor();
  const editorState = useEditorState({
    editor,
    selector: (ctx) => ({
      canToggleUnderline: ctx.editor?.can().chain().toggleUnderline().run() ?? false,
      isUnderline: ctx.editor?.isActive("underline") || false,
    }),
  });

  if (!editor || !editorState) {
    return null;
  }

  return (
    <EditorButton
      {...props}
      onClick={() => editor.chain().focus().toggleUnderline().run()}
      active={editorState.isUnderline}
      disabled={!editorState.canToggleUnderline}
      icon="format_underlined"
      tooltip="Underline"
    />
  );
};
